<template>
  <div>
    <div
      id="map-tab"
      title="Map Tab"
      class="p-0 m-0"
    >
      <Map ref="map-ref" />
    </div>
    
  </div>
</template>

<script>
import Map from './map';
export default {
  components: {
    Map
  },
  methods: {
    show(mapData) {
        this.$refs['map-ref'].initializeMap(mapData)
    },
  }
};
</script>

<style>
@import './styles.scss';
</style>
